import { render, staticRenderFns } from "./OrdreEixidaMPCreate.vue?vue&type=template&id=9c354338&scoped=true"
import script from "./OrdreEixidaMPCreate.vue?vue&type=script&lang=js"
export * from "./OrdreEixidaMPCreate.vue?vue&type=script&lang=js"
import style0 from "./OrdreEixidaMPCreate.vue?vue&type=style&index=0&id=9c354338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c354338",
  null
  
)

export default component.exports